// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__1UzXs","darkMode":"Footer_darkMode__3aj8A","wrapperInner":"Footer_wrapperInner__3k0jc","header":"Footer_header__2Lo8V"};